import * as Yup from 'yup'
import { InEditingMode, InEditingPrincipal } from "../../states/GlobalState"
import Api from '../../services/api'
// import DateFnsUtils from '@date-io/date-fns'
// import { it } from 'date-fns/locale';
import ValidationCache from '../../utils/validationCache';
import { OptionType } from '../../types/constants';
import uuid from 'uuidv4'
import { Principal } from '../../models/principal';
import { Company } from '../../models/company';

const passwordValidationRegex = /^.*(?=.{8,})(?=.*\d)(?=.*[@#$%^&+=_.!])(?=.*[A-Z]).*$/
const passwordValidationHint = "La password deve essere lunga almeno 8 caratteri, contenere almeno un numero, un carattere maiuscolo ed un carattere speciale: @#$%^&+=_.!"
const validationCache = new ValidationCache('default', 60000);

const setCacheName = (newName: string) => {
    validationCache.setName(newName)
}
const clearCache = () => {
    validationCache.clear()
}
const reformatQuery = (query: string) => {
    let q = query.replace(/[_]/g, '[_]').replace(/[*]/g, '%')
    if(q.endsWith('$')) {
        console.log('query finisce per $')
        q = q.replace(/[$]$/, '')
    } else if(!q.endsWith('%')) {
        q += '%'
    }
    q = q.replace(/%/g, '%25').replace(/[ ]/g, '%20').replace(/#/g, '%23')
    return q
}

// const dateFns = new DateFnsUtils({locale: it})
// const isExpired = (pwexp: DateTimeISO) => {
//     return dateFns.date(pwexp).getTime() < Date.now()
// }

// const isAcceptable = (ubo: Principal, filters: UsersFilterType) => {
//     return !(
//         (filters.pwExpireFilter && ((filters.noPwExpire && isExpired(ubo.pwExpire)) || (!filters.noPwExpire && !isExpired(ubo.pwExpire)))) ||
//         (filters.lockedFilter && ((!filters.onlyLocked && ubo.isLocked) || (filters.onlyLocked && !ubo.isLocked)))
//     )
// }

const newInEditPrincipal = (newId: number, companyId: number): Principal => {
    const newPrincipal: Principal = {
        Id: newId,
        Name: '',
        Surname: '',
        Role: '',
        Username: '',
        Mail: '',
        InsertDate: new Date(),
        InsertUser: '',
        UpdateDate: new Date(),
        UpdateUser: '',
        Phone: '',
        // State: 'A',
        Taxcode: '',
        Password: '',
        Disabled: undefined,
        CompanyId: companyId,
        ApplicationForfetari: false,
        ApplicationConvenienza: false,
        ApplicationBudget: false,
        ApplicationEasyStart: false,
        UserCreation: false,
        Error: '',
        PrincipalAuth: [],
        agencyName: ''
        // Company: Company.newItem()
        // modified: true,
        // mode: InEditingMode.New,
        ,
        ReportEnabled: false
    }
    return newPrincipal as Principal;
}

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class PrincipalServiceValidation {
    levels: OptionType[];
    // ownerContext: string;
    // checkOwnerContextErrorMessage: string;

    // checkOwnerContext = (value: string) => {
    //     value = value || ''
    //     console.log(`checkOwnerContext ${value}`)
    //     return (value.startsWith(this.ownerContext))
    // }

    constructor(adLevels: OptionType[]) {
        // console.log(`UserServiceValidation.ctor ${adRole}`)
        this.levels = adLevels;
        // this.ownerContext = adOwnerContext
        // this.checkOwnerContextErrorMessage = `L'owner deve iniziare per ${this.ownerContext}`
    }

    principalFormSchemaBase = () => {
        // const ownerContext = this.ownerContext;
        return Yup.object().shape({
            // oid: Yup.number(),
            Id: Yup.number().label('Id').required(),
            Username: Yup.string().label('Username').required('Lo userName è obbligatorio'),
            Name: Yup.string().label('Name').required('Il Nome è obbligatorio'),
            Surname: Yup.string().label('Surname').required('Il Cognome è obbligatorio'),
            TaxCode: Yup.string().label('TaxCode').nullable(),
            Mail: Yup.string().label('Mail').email('Invalid mail')
                .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                .required('La mail è obbligatorio'),
            CompanyId: Yup.number().label('CompanyId').required('La company è obbligatoria'),
            Phone: Yup.string().label('Phone').nullable(),
            Disable: Yup.date().label('Disabled').nullable(),
            Role: Yup.string().label('Role').required('Il ruolo è obbligatorio'),
            // InsertDate: Yup.string().label('InsertDate'),
            // InsertUser: Yup.string().label('InsertUser'),
            // UpdateDate: Yup.string().label('UpdateDate'),
            // UpdateUser: Yup.string().label('UpdateUser'),
        })
    }
    
    // principalSchema = () => Yup.object().shape({
    //     // oid: Yup.number(),
    //     id: Yup.string(),
    //     Name: Yup.string(),
    //     VatNumber: Yup.string(),
    //     Code: Yup.string(),
    //     CityCode: Yup.string(),
    //     Address: Yup.string(),
    //     CompanyId: Yup.number(),
    //     PrincipalCounter: Yup.number(),
    //     ProvinceCode: Yup.string().nullable(),
    //     Cap: Yup.string().nullable(),
    // })
    
    // checkUnicity(this: any, value: string) {
    //     let item = validationCache.getItem(value)
    //     if(item !== undefined) {
    //         return item.value
    //     }
    //     if(value) {
    //         return Api.validId(value).then(valid => {
    //             validationCache.put(value, valid)
    //             return valid
    //         })
    //     }
    //     validationCache.put(value, false)
    //     return false;
    // }
}

export default {
    newInEditPrincipal,
    setCacheName,
    clearCache,
    reformatQuery,
}